import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));

// Service Pages
const GeneratorPage = lazy(() => import('../pages/services/generator/page'));
const SolarPage = lazy(() => import('../pages/services/solar/page'));
const IndustrialEquipmentPage = lazy(() => import('../pages/services/industrial-equipment/page'));
const SwitchgearAutomationPage = lazy(() => import('../pages/services/switchgear-automation/page'));
const BackupSystemsPage = lazy(() => import('../pages/services/backup-systems/page'));
const MotorRewindingPage = lazy(() => import('../pages/services/motor-rewinding/page'));
const AirConditionerPage = lazy(() => import('../pages/services/air-conditioner/page'));
const ElectronicsPage = lazy(() => import('../pages/services/electronics/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/gallery',
    element: <GalleryPage />
  },
  {
    path: '/services/generator',
    element: <GeneratorPage />
  },
  {
    path: '/services/solar',
    element: <SolarPage />
  },
  {
    path: '/services/industrial-equipment',
    element: <IndustrialEquipmentPage />
  },
  {
    path: '/services/switchgear-automation',
    element: <SwitchgearAutomationPage />
  },
  {
    path: '/services/backup-systems',
    element: <BackupSystemsPage />
  },
  {
    path: '/services/motor-rewinding',
    element: <MotorRewindingPage />
  },
  {
    path: '/services/air-conditioner',
    element: <AirConditionerPage />
  },
  {
    path: '/services/electronics',
    element: <ElectronicsPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
